module.exports = __webpack_public_path__ + "img/call.5f78d8fd.svg";